export const statistics = new Map([
  ['交易订单金额', []],
  ['交易订单量', []],
]);
export const titleName = new Map([
  ['statistics', ['累计数据和趋势', '渠道占比统计']],
  ['statistics/interface', ['接口累计调用次数统计', '每日最大并发值统计']],
]);
